<template lang="pug">
.error-400.text-large
  .error-400__message システムエラーが発生しました。最初からやり直してください。
  a(:href='returnPage') 戻る
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Error400 extends Vue {
  private get returnPage(): string {
    return this.$bcbtCookies.returnUrl.get()
  }
}
</script>

<style lang="stylus" scoped>
.error-400
  margin 50px

  &__message
    margin-bottom 20px
</style>
